import React from 'react';
import { times } from 'lodash';
import { Stack } from '@fiverr-private/layout_components';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';
import { type Types } from '@fiverr-private/theme';
import { useTagsContext } from './TagsContext/TagsContext';

export const TagsSkeleton: React.FC = () => {
    const { numOfLines, tagsLayout } = useTagsContext();
    const skeletonHeight: Types.ResponsiveHeightType = `${tagsLayout.tagLineHeightPx}px`;

    return (
        <Skeleton width="auto">
            <Stack direction="column" gap={tagsLayout.gap}>
                {times(numOfLines).map((lineNum) => (
                    <SkeletonSquare
                        key={lineNum}
                        height={skeletonHeight}
                        width={lineNum % 2 === 0 ? tagsLayout.evenLineSkeletonWidth : tagsLayout.oddLineSkeletonWidth}
                    />
                ))}
            </Stack>
        </Skeleton>
    );
};
